export const VISITOR_RECORDED_STORAGE_KEY = 'cm_visitor_recorded';

// Re-record a given visitor+attribution at most this often. MUST stay below the API
// VISITOR_TTL_MS (24h) so a returning attributed visitor keeps a live web_visitor row.
export const VISITOR_RECORD_REFRESH_MS: number = 12 * 60 * 60 * 1000;
